// integration started on 21/10/2024

// SideMenu
export const get_SideMenus = "get_SideMenus";
// SideMenu

// SignIn Page
export const post_SignIn_Data = "post_SignIn_Data";
export const post_resendOtp_Data = "post_resendOtp_Data";
export const SET_SIGNIN_DETAILS = 'SET_SIGNIN_DETAILS';
// SignIn Page

// Verify Company
export const post_Resend_Verify_Email = "post_Resend_Verify_Email";
// Verify Company

// Forgot Password
export const post_Forgot_Password = "post_Forgot_Password";
// Forgot Password

// Reset Password
export const post_Reset_Password = "post_Reset_Password";
// Reset Password

// Total Data Count
export const Get_Total_Data_Count = "Get_Total_Data_Count";
// Total Data Count

// Switch To Client
export const post_Switch_To_Client = "post_Switch_To_Client";
// Switch To Client

// Switch To SuperAdmin
export const post_Switch_To_SuperAdmin = "post_Switch_To_SuperAdmin";
// Switch To SuperAdmin

// SignIn generate token
export const get_SignIn_Token = "get_SignIn_Token";
// SignIn generate token

// Profile Settings Set Password
export const get_Profile_Details = "get_Profile_Details";
export const post_Profile_Settings_Set_Password = "post_Profile_Settings_Set_Password";
export const get_TimeZone_Dropdown = "get_TimeZone_Dropdown";
export const get_Profile_Password_Otp = "get_Profile_Password_Otp";
export const update_Profile_Data = "update_Profile_Data";
// Profile Settings Set Password

// Module Permissions
export const get_Role_Based_Module_Permissions = "get_Role_Based_Module_Permissions";
// Module Permissions

// Customer Management
export const post_Customer_Data = "post_Customer_Data";
export const get_Assigned_Modules = "get_Assigned_Modules";
export const get_Company_Data = "get_Company_Data";
export const download_Company_Data = "download_Company_Data";
export const get_Single_Company_Data = "get_Single_Company_Data";
export const get_Country_Code = "get_Country_Code";
export const get_Company_Dropdown = "get_Company_Dropdown";
export const get_generated_Company_Code = "get_generated_Company_Code";
export const get_Custom_Fields_For_Company = "get_Custom_Fields_For_Company";
export const post_Custom_Fields_Value_For_Company = "post_Custom_Fields_Value_For_Company";
export const get_Customer_Classification_Dropdown = "get_Customer_Classification_Dropdown";
export const get_Customer_Dashboard_CardData = "get_Customer_Dashboard_CardData";
export const get_Customer_Details_ChartData = "get_Customer_Details_ChartData";
export const get_Customer_Dashboard_RelationShipType_Chart = "get_Customer_Dashboard_RelationShipType_Chart";
export const get_Customer_Dashboard_LicenceSplitUp_Data = "get_Customer_Dashboard_LicenceSplitUp_Data";
export const get_Customer_Dashboard_Status_ChartData = "get_Customer_Dashboard_Status_ChartData";
export const get_Customer_Dashborad_AssignedModules_Data = "get_Customer_Dashborad_AssignedModules_Data";
export const get_Customer_Dashboard_NoOfLicence_ChartData = "get_Customer_Dashboard_NoOfLicence_ChartData";
export const get_Customer_ModuleField_Dropdown = "get_Customer_ModuleField_Dropdown";
export const get_Custom_Fields_For_Customers = "get_Custom_Fields_For_Customers";
export const get_Customer_CustomField_Data = "get_Customer_CustomField_Data";
// Customer Management

// User Management
export const get_User_Data = "get_User_Data";
export const get_Single_User_Data = "get_Single_User_Data";
export const get_Role_Dropdown_Data = "get_Role_Dropdown_Data";
export const get_ReportingTo_Dropdown_Data = "get_ReportingTo_Dropdown_Data";
export const post_User_Data = "post_User_Data";
export const post_User_Sloc_Data = "post_User_Sloc_Data";
export const post_User_Plant_Data = "post_User_Plant_Data";
export const get_Sloc_Dropdown_Data = "get_Sloc_Dropdown_Data";
export const get_Branch_Dropdown_Data = "get_Branch_Dropdown_Data";
export const get_BusinessUnit_Dropdown_Data = "get_BusinessUnit_Dropdown_Data";
export const get_Custom_Fields_For_Users = "get_Custom_Fields_For_Users";
export const get_User_Dropdown = "get_User_Dropdown";
export const get_User_Reporting_Designation_Dropdown = "get_User_Reporting_Designation_Dropdown";
export const get_Licence_Dashboard_CardData = "get_Licence_Dashboard_CardData";
export const get_Users_ModuleField_Dropdown = "get_Users_ModuleField_Dropdown";
export const get_User_CustomField_Data = "get_User_CustomField_Data";
export const get_User_Dashboard_Licence_Status_Data = "get_User_Dashboard_Licence_Status_Data";
export const get_Licence_Dashboard_BarChart_Licence_Details_Data = "get_Licence_Dashboard_BarChart_Licence_Details_Data";
export const get_Licence_Dashboard_BarChart_Licence_Split_Up_Data = "get_Licence_Dashboard_BarChart_Licence_Split_Up_Data";
export const post_User_Management_Bulk_Upload_Data = "post_User_Management_Bulk_Upload_Data";
export const get_User_Management_Bulk_Upload_Template = "get_User_Management_Bulk_Upload_Template";
// User Management

// Complaint/Escalation 
export const get_Complaint_Data = "get_Complaint_Data";
export const get_Single_Complaint_Data = "get_Single_Complaint_Data";
export const get_IssueType_Dropdown_Data = "get_IssueType_Dropdown_Data";
export const post_Complaint_Escalation_Data = "post_Complaint_Escalation_Data";
export const upload_File = "upload_File";
export const get_Complaint_Escalation_Dashboard_CardData = "get_Complaint_Escalation_Dashboard_CardData";
export const get_Complaint_Escalation_Ticket_Data = "get_Complaint_Escalation_Ticket_Data";
export const get_Complaint_Escalation_PriorityStatus_Data = "get_Complaint_Escalation_PriorityStatus_Data";
export const get_Complaint_Escalation_Status_Data = "get_Complaint_Escalation_Status_Data";
export const get_Complaint_Escalation_BranchStatus_Data = "get_Complaint_Escalation_BranchStatus_Data";
export const get_Complaint_Escalation_IssueType_Data = "get_Complaint_Escalation_IssueType_Data";
export const get_Complaint_Escalation_ModuleField_Dropdown = "get_Complaint_Escalation_ModuleField_Dropdown";
export const post_Assign_Complaint_Data = "post_Assign_Complaint_Data";
export const post_Complaint_Escalation_Status_Change = "post_Complaint_Escalation_Status_Change";
export const get_Complaint_Status_Dropdown = "get_Complaint_Status_Dropdown";
export const get_Complaint_History_Data = "get_Complaint_History_Data";
export const get_Technical_Data = "get_Technical_Data";
export const get_QA_Data = "get_QA_Data";
export const post_Complaint_Escalation_ERT_Data = "post_Complaint_Escalation_ERT_Data";
export const get_Custom_Fields_For_Complaints = "get_Custom_Fields_For_Complaints";
export const get_Complaint_CustomField_Data = "get_Complaint_CustomField_Data";
// Complaint/Escalation 

// Service Level Agreement
export const get_AssignedTo_SLA_Data = "get_AssignedTo_SLA_Data";
export const get_Single_AssignedTo_SLA_Data = "get_Single_AssignedTo_SLA_Data";
export const post_AssignedTo_SLA_Data = "post_AssignedTo_SLA_Data";
export const get_AssignedTo_SLA_Type_Dropdown = "get_AssignedTo_SLA_Type_Dropdown";
export const get_SLA_Category_Dropdown = "get_SLA_Category_Dropdown";
export const get_SLA_Dashboard_CardData = "get_SLA_Dashboard_CardData";
export const get_SLA_Dashboard_SLA_Type_Status_Chart_Data = "get_SLA_Dashboard_SLA_Type_Status_Chart_Data";
export const get_SLA_Dashboard_SLA_Types_Chart_Data = "get_SLA_Dashboard_SLA_Types_Chart_Data";
export const get_SLA_Dashboard_AssignedScore_Data = "get_SLA_Dashboard_AssignedScore_Data";
export const get_SLA_Dashboard_Total_SLA_Chart_Data = "get_SLA_Dashboard_Total_SLA_Chart_Data";
export const get_SLA_Dashboard_Checklist_Status_Chart_Data = "get_SLA_Dashboard_Checklist_Status_Chart_Data";
export const get_AssignTo_SLA_ModuleField_Dropdown = "get_AssignTo_SLA_ModuleField_Dropdown";
export const get_Update_SLA_Data = "get_Update_SLA_Data";
export const post_Update_SLA_Data = "post_Update_SLA_Data";
export const get_User_Slocs_Dropdown = "get_User_Slocs_Dropdown";
// Service Level Agreement

// Workqueues
export const get_Workqueue_Data = "get_Workqueue_Data";
export const get_Single_Workqueue_Data = "get_Single_Workqueue_Data";
export const update_Workqueue_Priority_Status = "update_Workqueue_Priority_Status";
export const post_Set_AssignTo_Data = "post_Set_AssignTo_Data";
export const get_User_Dropdown_Based_Department = "get_User_Dropdown_Based_Department";
export const get_Workqueue_ModuleField_Dropdown = "get_Workqueue_ModuleField_Dropdown";
export const get_View_Assigned_Workqueue_Data = "get_View_Assigned_Workqueue_Data";
// Workqueues

// Leave and Holiday
export const get_Leave_Balance_Data = "get_Leave_Balance_Data";
export const get_Single_Leave_Balance_Data = "get_Single_Leave_Balance_Data";
export const post_Leave_Balance_Data = "post_Leave_Balance_Data";
export const post_Apply_Leave = "post_Apply_Leave";
export const get_Leave_Data = "get_Leave_Data";
export const update_Leave_Status = "update_Leave_Status";
export const get_Pending_Leave_Data = "get_Pending_Leave_Data";
export const get_Approved_Leave_Data = "get_Approved_Leave_Data";
export const get_Rejected_Leave_Data = "get_Rejected_Leave_Data";
export const get_Single_Leave_Data = "get_Single_Leave_Data";
export const get_Leaves_Count = "get_Leaves_Count";
export const get_Leave_Balance_Count = "get_Leave_Balance_Count";
export const get_Leave_duration = "get_Leave_duration";
// Leave and Holiday

// System Logging
export const get_ModuleName_For_SystemLogging = "get_ModuleName_For_SystemLogging";
// Exception Log
export const get_Exception_Logging_Data = "get_Exception_Logging_Data";
export const get_Single_Exception_Logging_Data = "get_Single_Exception_Logging_Data";
// Exception Log

// Audit Trial
export const get_Audit_Trial_Data = "get_Audit_Trial_Data";
export const download_Audit_Trial_Data = "download_Audit_Trial_Data";
// Audit Trial
// System Logging

// Settings Department
export const post_Department_Data = "post_Department_Data";
export const get_Department_Data = "get_Department_Data";
export const get_Single_Department_Data = "get_Single_Department_Data";
export const get_Department_ModuleField_Dropdown = "get_Department_ModuleField_Dropdown";
export const post_Department_Bulk_Upload_Data = "post_Department_Bulk_Upload_Data";
// Settings Department

// Settings Customer Classification
export const post_Customer_Classification_Data = "post_Customer_Classification_Data";
export const get_Customer_Classification_Data = "get_Customer_Classification_Data";
export const get_Single_Customer_Classification_Data = "get_Single_Customer_Classification_Data";
export const get_Customer_Classification_ModuleField_Dropdown = "get_Customer_Classification_ModuleField_Dropdown";
export const post_Customer_Classification_Bulk_Upload_Data = "post_Customer_Classification_Bulk_Upload_Data";
// Settings Customer Classification

// Settings Designation
export const get_Designation_Data = "get_Designation_Data";
export const post_Designation_Data = "post_Designation_Data";
export const get_Department_Dropdown = "get_Department_Dropdown";
export const get_Reporting_Designation_Dropdown = "get_Reporting_Designation_Dropdown";
export const get_Single_Designation_Data = "get_Single_Designation_Data";
export const get_Designation_ModuleField_Dropdown = "get_Designation_ModuleField_Dropdown";
export const post_Designation_Bulk_Upload_Data = "post_Designation_Bulk_Upload_Data";
// Settings Designation

// Settings Issue Types
export const get_Issue_Type_Data = "get_Issue_Type_Data";
export const post_Issue_Types_Data = "post_Issue_Types_Data";
export const get_Single_Issue_Types_Data = "get_Single_Issue_Types_Data";
export const get_Issue_Type_ModuleField_Dropdown = "get_Issue_Type_ModuleField_Dropdown";
export const post_Issue_Type_Bulk_Upload_Data = "post_Issue_Type_Bulk_Upload_Data";
// Settings Issue Types

// Settings SLA
export const get_Settings_SLA_Data = "get_Settings_SLA_Data";
export const post_Settings_SLA_Data = "post_Settings_SLA_Data";
export const get_Single_Settings_SLA_Data = "get_Single_Settings_SLA_Data";
export const get_Settings_SLA_ModuleField_Dropdown = "get_Settings_SLA_ModuleField_Dropdown";
export const post_Sla_Categories_Bulk_Upload_Data = "post_Sla_Categories_Bulk_Upload_Data";
// Settings SLA

// Settings Module
export const post_Modules_Data = "post_Modules_Data";
export const get_Module_Data = "get_Module_Data";
export const get_Single_Module_Data = "get_Single_Module_Data";
// Settings Module

// Settings Sub Module
export const post_Sub_Modules_Data = "post_Sub_Modules_Data";
export const get_Sub_Module_Data = "get_Sub_Module_Data";
export const get_Single_Sub_Module_Data = "get_Single_Sub_Module_Data";
export const get_SubModule_Dropdown = "get_SubModule_Dropdown";
// Settings Sub Module

// Settings System Numbering
export const get_System_Numbering = "get_System_Numbering";
export const get_Singel_System_Numbering = "get_Singel_System_Numbering";
export const post_System_Numbering = "post_System_Numbering";
export const get_System_Numbering_ModuleField_Dropdown = "get_System_Numbering_ModuleField_Dropdown";
export const post_System_Numbering_Bulk_Upload_Data = "post_System_Numbering_Bulk_Upload_Data";
// Settings System Numbering

// Settings Work Queues Rules
export const get_Settings_WorkQueues_Rule = "get_Settings_WorkQueues_Rule";
export const get_Settings_Single_WorkQueues_Rule = "get_Settings_Single_WorkQueues_Rule";
export const get_Settings_WorkQueues_FieldName_Rule = "get_Settings_WorkQueues_FieldName_Rule";
export const post_Settings_WorkQueues_Rule_Data = "post_Settings_WorkQueues_Rule_Data";
export const post_Run_WorkQueue_Data = "post_Run_WorkQueue_Data";
export const get_WorkQueue_Rule_ModuleField_Dropdown = "get_WorkQueue_Rule_ModuleField_Dropdown";
// Settings Work Queues Rules

// Settings Role
export const get_Roles_Data = "get_Roles_Data";
export const get_Single_Roles_Data = "get_Single_Roles_Data";
export const post_Roles_Data = "post_Roles_Data";
export const get_Modules_SubModules_Data = "get_Modules_SubModules_Data";
export const get_Roles_ModuleField_Dropdown = "get_Roles_ModuleField_Dropdown";
export const get_Roles_Advance_Filter_Data = "get_Roles_Advance_Filter_Data";
export const post_Roles_Bulk_Data = "post_Roles_Bulk_Data";
// Settings Role

// Settings Custom Fields
export const get_CustomFields_Data = "get_CustomFields_Data";
export const get_Single_CustomFields_Data = "get_Single_CustomFields_Data";
export const post_CustomFields_Data = "post_CustomFields_Data";
export const get_CustomFields_ModuleField_Dropdown = "get_CustomFields_ModuleField_Dropdown";
export const post_CustomFields_Bulk_Upload_Data = "post_CustomFields_Bulk_Upload_Data";
// Settings Custom Fields

// Settings Leave Policy
export const post_Leave_Policy_Data = "post_Leave_Policy_Data";
export const get_Leave_Policy_Data = "get_Leave_Policy_Data";
export const get_Single_Leave_Policy_Data = "get_Single_Leave_Policy_Data";
export const get_Leave_Type_Dropdown = "get_Leave_Type_Dropdown";
export const get_Leave_Policy_ModuleField_Dropdown = "get_Leave_Policy_ModuleField_Dropdown";
export const post_Leave_Policy_BulkUpload_Data = "post_Leave_Policy_BulkUpload_Data";
// Settings Leave Policy

// Settings Holiday Policy
export const get_Holiday_Policy_Data = "get_Holiday_Policy_Data";
export const get_SingleHoliday_Policy_Data = "get_SingleHoliday_Policy_Data";
export const post_Holiday_Policy_Data = "post_Holiday_Policy_Data";
export const get_Country_Name_Dropdown = "get_Country_Name_Dropdown";
export const get_Holiday_Name_Dropdown = "get_Holiday_Name_Dropdown";
export const get_Holiday_Policy_ModuleField_Dropdown = "get_Holiday_Policy_ModuleField_Dropdown";
export const post_Holiday_Policy_BulkUpload_Data = "post_Holiday_Policy_BulkUpload_Data";
// Settings Holiday Policy

// Settings Financial Approval
export const get_Financial_Approval_Data = "get_Financial_Approval_Data";
export const get_Single_Financial_Approval_Data = "get_Single_Financial_Approval_Data";
export const get_Approval_Level_Dropdown = "get_Approval_Level_Dropdown";
export const post_Financial_Approval_Data = "post_Financial_Approval_Data";
export const get_Financial_Approval_ModuleField_Dropdown = "get_Financial_Approval_ModuleField_Dropdown";
// Settings Financial Approval

// Settings Functional Approval
export const get_Functional_Approval_Data = "get_Functional_Approval_Data";
export const get_Single_Functional_Approval_Data = "get_Single_Functional_Approval_Data";
export const post_Functional_Approval_Data = "post_Functional_Approval_Data";
export const get_Functional_Approval_ModuleField_Dropdown = "get_Functional_Approval_ModuleField_Dropdown";
// Settings Functional Approval

// Settings Leave Approval
export const get_Leave_Approval_Data = "get_Leave_Approval_Data";
export const get_Single_Leave_Approval_Data = "get_Single_Leave_Approval_Data";
export const post_Leave_Approval_Data = "post_Leave_Approval_Data";
export const get_Leave_Approval_ModuleField_Dropdown = "get_Leave_Approval_ModuleField_Dropdown";
// Settings Leave Approval

// Settings Escalation Approval
export const get_Escalation_Approval_Data = "get_Escalation_Approval_Data";
export const get_Single_Escalation_Approval_Data = "get_Single_Escalation_Approval_Data";
export const post_Escalation_Approval_Data = "post_Escalation_Approval_Data";
export const get_Escalation_Approval_ModuleField_Dropdown = "get_Escalation_Approval_ModuleField_Dropdown";

// Settings Escalation Approval

// Settings Complaints Approval
export const get_Complaints_Approval_Data = "get_Complaints_Approval_Data";
export const get_Single_Complaints_Approval_Data = "get_Single_Complaints_Approval_Data";
export const post_Complaints_Approval_Data = "post_Complaints_Approval_Data";
export const get_Complaints_Approval_ModuleField_Dropdown = "get_Complaints_Approval_ModuleField_Dropdown";
// Settings Complaints Approval

// Settings Organization Chart
export const get_Organization_Chart = "get_Organization_Chart";
// Settings Organization Chart

// Settings Menubar Enable and Disable
export const get_Module_SubModules = "get_Module_SubModules";
export const post_Modules_SubModules = "post_Modules_SubModules";
export const post_CustomField_Label_Change = "post_CustomField_Label_Change";
export const get_Module_Field_Names = "get_Module_Field_Names";
export const post_Module_Field_Names = "post_Module_Field_Names";
// Settings Menubar Enable and Disable

// Settings Dynamic Dashboards
export const get_Dynamic_Dashboard_Data = "get_Dynamic_Dashboard_Data";
export const get_Dynamic_Dashboard_Catogery_Dropdown = "get_Dynamic_Dashboard_Catogery_Dropdown";
export const post_Dynamic_Dashboard_Data = "Dynamic_Dashboard_Data";
export const get_Single_Dynamic_Dashboard_Data = "get_Single_Dynamic_Dashboard_Data";
export const post_Default_Dashboard_Data = "post_Default_Dashboard_Data";
export const post_Dynamic_Dashboard_Bulk_Data = "post_Dynamic_Dashboard_Bulk_Data";
// Settings Dynamic Dashboards

// Settings Module Fields
export const get_Module_Fields_Data = "get_Module_Fields_Data";
export const post_Module_Fields_Data = "post_Module_Fields_Data";
export const get_Column_Name = "get_Column_Name";
export const get_Single_Module_Field_Data = "get_Single_Module_Field_Data";
export const get_Module_Field_Modules = "get_Module_Field_Modules";
// Settings Module Fields

// Module-2 7/5/2025
// Location Master
// Zone Master
export const post_Zone_Master_Data = "post_Zone_Master_Data";
export const get_Zone_Master_Data = "get_Zone_Master_Data";
export const get_Single_Zone_Master_Data = "get_Single_Zone_Master_Data";
export const get_Zone_Class_Dropdown_Data = "get_Zone_Class_Dropdown_Data";
export const get_Zone_Category_Dropdown_Data = "get_Zone_Category_Dropdown_Data";
export const get_ParentCode_Dropdown_Data = "get_ParentCode_Dropdown_Data";
// Zone Master

// Storage Type Master
export const get_Storage_Type_Master_Data = "get_Storage_Type_Master_Data";
export const get_Single_Storage_Type_Master_Data = "get_Single_Storage_Type_Master_Data";
export const post_Storage_Type_Master_Data = "post_Storage_Type_Master_Data";
// Storage Type Master

// Bin Master
export const post_Bin_Master_Data = "post_Bin_Master_Data";
export const get_Bin_Master_Data = "get_Bin_Master_Data";
export const get_Single_Bin_Master_Data = "get_Single_Bin_Master_Data";
export const get_Uom_Dropdown_Data = "get_Uom_Dropdown_Data";
export const get_Weight_Uom_Dropdown_Data = "get_Weight_Uom_Dropdown_Data";
export const get_Storage_Type_Dropdown_Data = "get_Storage_Type_Dropdown_Data";
export const get_Bin_Level_Dropdown_Data = "get_Bin_Level_Dropdown_Data";
export const download_Bin_Master_Data = "download_Bin_Master_Data";
// Bin Master
// Location Master

// Standards Master
// MRP Type
export const get_Mrp_Type_Data = "get_Mrp_Type_Data";
export const get_Single_Mrp_Type_Data = "get_Single_Mrp_Type_Data";
export const post_Mrp_Type_Data = "post_Mrp_Type_Data";
// MRP Type
// Unit of Measure
export const get_Unit_Of_Measure_Data = "get_Unit_Of_Measure_Data";
export const get_Single_Unit_Of_Measure_Data = "get_Single_Unit_Of_Measure_Data";
export const get_Unit_Of_Measure_Class_Dropdown_Data = "get_Unit_Of_Measure_Class_Dropdown_Data";
export const get_Unit_Of_Measure_MeasureOf_Dropdown_Data = "get_Unit_Of_Measure_MeasureOf_Dropdown_Data";
export const post_Unit_Of_Measure_Data = "post_Unit_Of_Measure_Data";
// Unit of Measure
// Material Group
export const get_Material_Group_Data = "get_Material_Group_Data";
export const get_Single_Material_Group_Data = "get_Single_Material_Group_Data";
export const post_Material_Group_Data = "post_Material_Group_Data";
export const get_Material_Group_Classification_Dropdown_Data = "get_Material_Group_Classification_Dropdown_Data";
// Material Group
// Material Type
export const get_Material_Type_Data = "get_Material_Type_Data";
export const post_Material_Type_Data = "post_Material_Type_Data";
export const get_Single_Material_Type_Data = "get_Single_Material_Type_Data";
// Material Type
// Stock Condition
export const get_Stock_Condition_Data = "get_Stock_Condition_Data";
export const get_Single_Stock_Condition_Data = "get_Single_Stock_Condition_Data";
export const post_Stock_Condition_Data = "post_Stock_Condition_Data";
// Stock Condition
// Lot Size
export const get_Lot_Size_Data = "get_Lot_Size_Data";
export const get_Single_Lot_Size_Data = "get_Single_Lot_Size_Data";
export const post_Lot_Size_Data = "post_Lot_Size_Data";
// Lot Size
// Standards Master

// Logistics Master
// Container Type
export const post_Logistics_Container_Type_Data = "post_Logistics_Container_Type_Data";
export const get_Logistics_Container_Type_Data = "get_Logistics_Container_Type_Data";
export const get_Single_Logistics_Container_Type_Data = "get_Single_Logistics_Container_Type_Data";
export const download_Logistics_Container_Type_Data = "download_Logistics_Container_Type_Data";
export const get_Rtms_Category_Dropdown_Data = "get_Rtms_Category_Dropdown_Data";
export const get_Product_Category_Dropdown_Data = "get_Product_Category_Dropdown_Data";
// Container Type
// Logistics Master

// Vendor Master
export const get_Vendor_Master_Data = "get_Vendor_Master_Data";
export const get_Single_Vendor_Master_Data = "get_Single_Vendor_Master_Data";
export const post_Vendor_Master_Data = "post_Vendor_Master_Data";
// Vendor Master

// Custom Dashboard
export const get_Custom_Dashboard_Options = "get_Custom_Dashboard_Options";
export const post_Custom_Dashboard_Data = "post_Custom_Dashboard_Data";
export const get_Custom_Dashboards = "get_Custom_Dashboards";
export const get_Custom_View = "get_Custom_View";
// Custom Dashboard

// Notifications
export const get_Notifications_Data = "get_Notifications_Data";
export const get_Single_Notification_Data = "get_Single_Notification_Data";
// Notifications

// Leave Management Dashboard
export const get_Leave_Status_Chart_Data = "get_Leave_Status_Chart_Data";
export const get_Leave_Dashboard_Card_Data = "get_Leave_Dashboard_Card_Data";
export const get_Leave_Dashboard_LeaveType_Chart_Data = "get_Leave_Dashboard_LeaveType_Chart_Data";
export const get_Leave_OverAll_Status_Chart_Data = "get_Leave_OverAll_Status_Chart_Data";
// Leave Management Dashboard

// Dashboard Category
export const get_Dashboard_Category_Data = "get_Dashboard_Category_Data";
export const post_Dashboard_Category_Data = "post_Dashboard_Category_Data";
export const get_Single_Dashboard_Data = "get_Single_Dashboard_Data";
export const post_Dashboard_Category_Bulk_Data = "post_Dashboard_Category_Bulk_Data";
// Dashboard Category

// Bulk Upload Template
export const get_Bulk_Upload_Template = "get_Bulk_Upload_Template";
// Bulk Upload Template